import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../../../../shared/components/accordion/Accordion";
import { Button } from "../../../../../../shared/components/button/Button";
import NavbarItemsPermissionsTable from "./NavbarItemsPermissionsTable";

const NavbarItemsPermissionsPanel = ({
  data,
  onDeletionHandler,
  onEditionHandler,
}) => {
  return (
    <>
      <Accordion type="single" collapsible>
        {data &&
          data.map((item, index) => {
            return (
              <AccordionItem
                key={`navbar_item_${index}`}
                value={item.role.code}
              >
                <AccordionTrigger>{item.role.name}</AccordionTrigger>
                <AccordionContent>
                  <div className="flex flex-row-reverse">
                    <Button
                      variant="destructive"
                      className="h-7 gap-1"
                      onClick={() => onDeletionHandler(item.id)}
                    >
                      Borrar
                    </Button>
                  </div>
                  <NavbarItemsPermissionsTable
                    data={item?.value?.navbarSections}
                    onEditionHandler={(formValues) =>
                      onEditionHandler(item.id, item.value, formValues)
                    }
                  />
                </AccordionContent>
              </AccordionItem>
            );
          })}
      </Accordion>
    </>
  );
};

export default NavbarItemsPermissionsPanel;
